// engine
import { ArContainer, ArSprite } from '@aceroll/core';

// library
import { ArSlotMachine } from '@aceroll/core/library';

// configs
import { slotMachineConfig } from '../../configs/slot-machine-config';
import { symbolsMap } from '../../configs/symbols-map-config';

export class SlotMachine extends ArSlotMachine {
    mainBackgroundSprite = null;
    bonusBackgroundSprite = null;

    constructor() {
        super(symbolsMap, slotMachineConfig);

        this.setup();
    }

    setup() {
        this.setupBackground();
        super.setup();
    }

    setupBackground() {
        this.background = new ArContainer('slot-machine-background');
        this.background.position.set(0, 0);

        this.mainBackgroundSprite = ArSprite.from('common-frame');
        this.bonusBackgroundSprite = ArSprite.from('common-frame');

        this.bonusBackgroundSprite.alpha = 0;

        this.background.addChild(this.mainBackgroundSprite, this.bonusBackgroundSprite);

        this.addChild(this.background);
    }

    async onBonus() { }

    async exitBonus() { }

    // visual

    async playRespinTrigger(position, counter) {
        await this.grid.playRespinTrigger(position, counter);
    }

    async updateRespinCounter(count) {
        await this.grid.updateRespinCounter(count);
    }

    unstick(positions) {
        this.grid.unstick(positions);
    }

    unstickAll() {
        this.grid.unstickAll();
    }

    async playMultipliers(position) {
        await this.grid.playMultiplier(position);
    }
    expand(position, multiplier) {
        return this.grid.expand(position, multiplier);
    }

    addToGrid(gameObject) {
        this.grid.addChild(gameObject);
        this.sortChildren();
    }
    removeFromGrid(gameObject) {
        this.grid.removeChild(gameObject);
    }

    playGroupWin(groups) {
        this.grid.playGroupWin(groups);
    }

    playMultiplier(action) {
        return this.grid.playMultiplier(action);
    }

}
